import React, { useState } from "react";
import { Button } from "@mui/material";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import { mainButtonStyles } from "../../Styles/Styles";

const StartChatButton = ({ adId, uniqueId, sellerId }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isChatStarted, setIsChatStarted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const startChat = async () => {
    if (loggedInUser) {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/chat/start-chat`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify({ uniqueId, sellerId }),
          }
        );

        const data = await response.json();

        if (response.ok) {
          if (data.chatId) {
            navigate(`/chat/${data.chatId}`);
            console.log("Chat started with ID:", data.chatId);
            setIsChatStarted(true);
          }
        } else {
          // Handle specific errors
          const error = data.error || "Failed to start chat. Please try again.";
          setErrorMessage(error);
        }
      } catch (error) {
        setErrorMessage("Unexpected error occurred. Please try again later.");
        console.error("Error starting chat:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setShowModal(true); // Show the modal if the user is not logged in
    }
  };

  const closeModal = () => {
    setShowModal(false); // Function to close the modal
  };

  return (
    <>
      <Button
        onClick={startChat}
        disabled={loading}
        className="main-button-style"
        sx={{
          mt: 4,
          ...mainButtonStyles,
        }}
      >
        {loading ? (
          <>
            <span>Starting Chat...</span>
            <QuestionAnswerOutlinedIcon fontSize="small" />
          </>
        ) : isChatStarted ? (
          <>
            <span>Chat Started</span>
            <QuestionAnswerOutlinedIcon fontSize="small" />
          </>
        ) : (
          <>
            <span>Start Chat</span>
            <QuestionAnswerOutlinedIcon fontSize="small" />
          </>
        )}
      </Button>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      <Modal open={showModal} onClose={closeModal} />
    </>
  );
};

export default StartChatButton;
